// types
import { ConfigProps } from 'types/config';
import { getDefaultHomePage } from 'utils/defaultPageOptions';

export const DASHBOARD_PATH = '/chats';

/**
 * מחזיר את עמוד ברירת המחדל הדינמי של המשתמש
 * אם אין הגדרה מותאמת אישית, מחזיר את DASHBOARD_PATH הקבוע
 */
export const getDynamicDashboardPath = (): string => {
  try {
    return getDefaultHomePage();
  } catch (error) {
    console.error('Error getting dynamic dashboard path:', error);
    return DASHBOARD_PATH;
  }
};
export const HORIZONTAL_MAX_ITEM = 7;

export enum MenuOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum ThemeDirection {
  LTR = 'ltr',
  RTL = 'rtl',
}

export enum AuthProvider {
  JWT = 'jwt',
  FIREBASE = 'firebase',
  AUTH0 = 'auth0',
  AWS = 'aws',
  SUPABASE = 'supabase',
}

export enum DropzopType {
  default = 'DEFAULT',
  standard = 'STANDARD',
}

export const APP_AUTH: AuthProvider = AuthProvider.JWT;

const config: ConfigProps = {
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: true,
  fontFamily: `'Heebo Variable', sans-serif`,
  borderRadius: 8,
  outlinedFilled: true,
  mode: ThemeMode.LIGHT,
  presetColor: 'default',
  i18n: 'he',
  themeDirection: ThemeDirection.RTL,
  container: false,
};

export default config;
